'use strict';

const navigationActions = [
	// insights
	'navigateLDPInsightKeywords',
	'navigateInsightKeywords',
	'navigateInsightOverview',
	'navigateInsightRating',
	'navigateInsightGoogle',
	'navigateInsightApple',
	'navigateOldInsightGoogle',
	'navigateOldLDPInsightGoogle',
	'navigateLDPInsightGoogle',
	'navigateInsightFacebook',
	'navigateLDPInsightFacebook',
	'navigateOldInsightFacebook',
	'navigateOldLDPInsightFacebook',
	'navigateInsightBing',
	'navigateInsightSystem',
	'navigateLocationInsightsOverview',
	'navigateLocationInsightsApple',
	// pages
	'navigateDashboard',
	'navigateDirectories',
	'navigateBrandPage',
	'navigateLocations',
	'navigateAddLocations',
	'navigateMediaReview',
	'navigateMediaLibrary',
	'navigateSpecialOpenHours',
	'navigateLocationDetails',
	'navigateConflictsResolver',
	'navigateLocationNetworkStatus',
	'navigateLocationsImport',
	'navigateNetworksFacebookBrandPages',
	'navigateNetworksGoogleBrandPages',
	'navigateWorkerLogWork',
	'downloadOldFacebookInsights',
	'downloadOldFacebookTopList',
	'downloadOldFacebookLocationInsights',
	'navigateLocationMediaReview'
];

// This id comes from the last part of the port name defined in `elm/shared/src/PlanHat/PlanHat.elm`
const elmPlanHatPortId = 'sendPlanHatTracking';

class PlanHatSocket {
	constructor(listingsManagerUrl) {
		this.socket = this.socketInit(listingsManagerUrl);
	}
	baseUrlInit(listingsManagerUrl) {
		return listingsManagerUrl
			.replace('https', 'wss')
			.replace('http', 'ws')
			.replace('/listings/', '/');
	}

	socketInit(listingsManagerUrl) {
		const baseUrl = this.baseUrlInit(listingsManagerUrl);
		const socketUrl = baseUrl + 'planhat';
		return window.io.connect(socketUrl, {
			transports: ['websocket'],
			path: '/listings/socket.io'
		});
	}

	getSocket() {
		return this.socket;
	}
}

class PlanHatTrackers {
	constructor($stateParams, pmtEnvService) {
		this.socket = new PlanHatSocket(pmtEnvService.listingsManagerUrl).getSocket();
		this.pmtEnvService = pmtEnvService;
		this.$stateParams = $stateParams;
		this.elmPlanHatPortId = elmPlanHatPortId;

		this.media = [];
	}

	track(action, info) {
		this.socket.emit('track', { siteName: this.$stateParams.site, action: action, info: info });
	}

	trackNavigation(action, url) {
		if (navigationActions.includes(action)) {
			const info = { url };
			this.track(action, info);
		}
	}

	trackDownloadReport(reportName) {
		this.track('downloadReport', reportName);
	}

	ctaLinkClicks(linkName) {
		this.track('ctaLinkClicks', linkName);
	}
	trackNavigate(url) {
		if (this.pmtEnvService.isPlacesApp) {
			this.track('navigatePlaces', { url: url });
		}
		if (this.pmtEnvService.isSocialApp) {
			this.track('navigateSocial', { url: url });
		}
	}

	trackMediaOpen(mediaId) {
		this.media[mediaId] = this.media[mediaId] || {};
		this.media[mediaId].opened = true;
		this.track('mediaReviewOpenDetailedMedia', mediaId);
	}
	trackMediaDelete(mediaId) {
		this.media[mediaId] = this.media[mediaId] || {};
		if (this.media[mediaId].opened) {
			this.track('mediaReviewDeleteMediaBeforeOpenDetails', mediaId);
		} else {
			this.track('mediaReviewDeleteMediaBeforeOpenDetails', mediaId);
		}
	}

	trackMediaReport(mediaId) {
		this.media[mediaId] = this.media[mediaId] || {};
		if (this.media[mediaId].opened) {
			this.track('mediaReviewReportMediaAfterOpenDetails', mediaId);
		} else {
			this.track('mediaReviewReportMediaBeforeOpenDetails', mediaId);
		}
	}

	trackUploadMediaClicked() {
		this.track('locationMediaReviewUploadButtonClicked');
	}
	trackMediaUploaded() {
		this.track('locationMediaReviewMediaUploadFlowFinished');
	}
}

angular.module('PinMeTo.services').factory('pmtPlanHatService', [
	'$stateParams',
	'pmtEnvService',
	function ($stateParams, pmtEnvService) {
		if (!window.io) {
			return {}; // CS app
		}
		const planHatTrackersInstance = new PlanHatTrackers($stateParams, pmtEnvService);
		window.pmtPlanHat = planHatTrackersInstance;
		return planHatTrackersInstance;
	}
]);
